/* eslint-env browser */
export const getUserLocaleFromBrowser = (): string[] =>
  ([] as string[]).concat(navigator.languages, navigator.language).filter(Boolean)
